import CloseIcon from "../assets/icons/x-close.svg";

export function Calendly(props: { url: string }) {
  return (
    <div class="h-full w-full p-4  ">
      <iframe src={props.url} class="w-full h-full" />
    </div>
  );
}
